import { createFileRoute } from '@tanstack/react-router';

import { AgentDetailPage } from '@/pages/agents/agent-detail-page';

function AgentDetailRoute() {
  const { agentId } = Route.useParams();
  return <AgentDetailPage agentId={agentId} />;
}

export const Route = createFileRoute('/agents/$agentId')({
  component: AgentDetailRoute,
});
